import React from 'react';

const InDangerIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#F48401"/>
      <path d="M15 7.01172L14.4531 7.94922L6.95312 20.9375L6.42578 21.875H23.5742L23.0469
        20.9375L15.5469 7.94922L15 7.01172ZM15 9.51172L21.4062 20.625H8.59375L15 9.51172ZM14.375
        13.75V17.5H15.625V13.75H14.375ZM14.375 18.125V19.375H15.625V18.125H14.375Z" fill="white"/>
    </svg>
  );
};

export default InDangerIcon;
